module.exports = __webpack_public_path__ + "assets/images/card-pg-2_e6940d6eb3440b2c1325c3143403133a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/card-pg-2.png
// module id = 190
// module chunks = 0